module.exports = __webpack_public_path__ + "src/assets/img/generating/5380a6eaa3842e0c28a1b6d33e4e0242.png";